import styled from '@emotion/styled';

export const BaseLayout = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

const ScrollArea = ({ children }: { children: React.ReactNode }) => {
  return <Scroll>{children}</Scroll>;
};

BaseLayout.ScrollArea = ScrollArea;

const Container = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  backface-visibility: hidden;
`;

const Scroll = styled.div`
  padding: 0 16px 28px 16px;
  flex: 1 1 0%;
  overflow-y: auto;
  min-height: 0;
`;
